module.exports = __webpack_public_path__ + "img/FR30628.90f14d62.png";